import { useRef, useState } from 'react';
import { SwapSet, isValidSet } from './swaps.domain';

type DraftSet = { key: number; reps: SwapSet['reps'] };

export const useDraftSets = (initial: SwapSet[]) => {
  const nextKey = useRef(0);
  const [sets, setSets] = useState<DraftSet[]>(() =>
    initial.map((set) => ({ key: nextKey.current++, reps: [...set.reps] })),
  );

  const updateSet = (key: number, reps: SwapSet['reps']) =>
    setSets((current) =>
      current.map((set) => (set.key === key ? { ...set, reps } : set)),
    );
  const addSet = () =>
    setSets((current) => [
      ...current,
      { key: nextKey.current++, reps: [0, 'reps'] },
    ]);
  const removeSet = (key: number) =>
    setSets((current) => current.filter((set) => set.key !== key));

  return {
    sets,
    valid: sets.every(isValidSet),
    updateSet,
    addSet,
    removeSet,
    toSwapSets: (): SwapSet[] => sets.map(({ reps }) => ({ reps })),
  };
};
